import { Injectable } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Resolve } from '@angular/router';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateResolverService implements Resolve<boolean> {
  constructor(private loginService: LoginService) {}

  resolve() {
    this.loginService.drawerOpened.next(true);

    return of(true);
  }
}
